import React, { useEffect, useState } from 'react';
import {
    Form,
    Row,
    Col,
    Card,
    Table,
    InputGroup,
    Image,
    Stack,
    Alert,
    Modal,
    Button,
    Spinner,
    Offcanvas,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import { ADD, AXE, CYL, PD, SPH } from './options';
import config from '../../Api/config';
import EyeUpload from '../../Assets/Img/eye_upload.png';
import {
    useAssignTestToDocMutation,
    useNotifyEyeTestMutation,
} from './eyetestApi';
import { useNavigate } from 'react-router';
import { useDoctorListMutation } from '../Doctor/doctorApi';
import { CircleAlert } from 'lucide-react';

const Notify = ({ idSum, setLoading }) => {
    const { t, i18n } = useTranslation();
    const [modalActive, setModalActive] = useState(false);
    const [notifyEyeTest] = useNotifyEyeTestMutation();
    const [buttonLoading, setButtonLoading] = useState(false);

    const handleSubmit = async () => {
        setButtonLoading(true);
        try {
            const { data } = await notifyEyeTest({ testNo: idSum });
            if (data) {
                setButtonLoading(false);
                setLoading(true);
            }
        } catch (error) {}
    };

    return (
        <>
            <Button
                variant="primary"
                onClick={() => setModalActive(true)}
                disabled={idSum.length == 0}
            >
                Notifier les clients
            </Button>
            <Modal show={modalActive} backdrop="static" keyboard={false}>
                <Modal.Body className="text-center">
                    <CircleAlert
                        size={60}
                        className="mb-4 mt-4"
                        color="#f8bb86"
                    />
                    <p>{t('areYouSure')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setModalActive(false)}
                    >
                        {t('okay')}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={buttonLoading}
                    >
                        {buttonLoading && (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        )}{' '}
                        {t('submitRequest')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Notify;
